// What this module needs from the app, typed structurally: nothing here imports the app, so the
// module can move to a package. `src/app/register-aes.tsx` builds it from real values and hands it to
// `createAesModule(host)` (module.ts). The HTTP clients are not members: they come from the shared
// registry, `getHttpClient` of `@vnetwork/margarita-core/http`.

import type { HostBase } from '@vnetwork/margarita-shell/host-base';

export interface AesHost extends Pick<HostBase, 'trackFeatureAction'> {
  /** Base URL of the DRM control plane, `/api/v1` included (`env.controlApiUrl`). */
  controlApiUrl: string;
  /** Public gateway host players call (`env.aesGatewayHost`); empty when unset, the module falls back. */
  aesGatewayHost: string;
}

let current: AesHost | null = null;

/** Called once by `createAesModule`, before any route renders. */
export function registerAesHost(host: AesHost): void {
  current = host;
}

/** The registered host. Throws when the module is used without `createAesModule(host)`. */
export function aesHost(): AesHost {
  if (!current) throw new Error('Aes: createAesModule(host) was not called before the module rendered');
  return current;
}

/** `host.trackFeatureAction`, resolved at call time so call sites read like the shared one. */
export const trackFeatureAction: AesHost['trackFeatureAction'] = (service, feature, verb, params) =>
  aesHost().trackFeatureAction(service, feature, verb, params);
